/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export interface Input {
  apiVersion?: string;
}

export async function deleteAccountToken(
  { apiVersion }: Input = {},
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().DELETE('/internal/account/tokens', {
    params: {},
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
